import React from 'react';
import './Homepage.css';
import Avatar from './Avatar';
import StatusBadge from './StatusBadge';
import Button from './Button';
import ProjectCard from './ProjectCard';
import Card from './Card';

// Local Image Assets
import imgImage from '../assets/images/kcm-cinema-bg.png';
import imgImage1 from '../assets/images/kcm-cinema-mockup.png';
import imgImage2 from '../assets/images/bukabantuan-revamp.png';
import imgImage3 from '../assets/images/neu-project.png';
import imgImage4 from '../assets/images/tokoku-landing.png';
import img from '../assets/images/roblox-fulfillment.png';
import img1 from '../assets/images/bukabantuan-chatbot.png';
import imgImageBackgroundRemoved1 from '../assets/images/avatar.png';
import imgEllipse244 from '../assets/images/ellipse-244.svg';
import imgEllipse242 from '../assets/images/ellipse-242.svg';
import imgUnion from '../assets/images/union.svg';

// Local Icon Assets
import imgSolarArrowRightUpLinear from '../assets/icons/arrow-right-up.svg';
import imgFrame1341149 from '../assets/icons/status-badge.svg';
import imgBasilLinkedinOutline from '../assets/icons/linkedin.svg';
import imgSimpleIconsUpwork from '../assets/icons/upwork.svg';
import imgLaGoodreads from '../assets/icons/goodreads.svg';
import imgGroup from '../assets/icons/substack.svg';

const Homepage = () => {
  const projects = [
    {
      id: 1,
      title: 'Tokoku Landing Page Improvement',
      description: 'Improving Tokoku landing page to increase register rate',
      imageUrl: imgImage4,
      url: 'https://drive.google.com/file/d/1a8OlDBGdoHOzeNx_80a7dSUyLs_JRuNR/view?usp=sharing'
    },
    {
      id: 2,
      title: 'Roblox Auto Fulfillment',
      description: 'This feature enable seller to connect their Roblox to Tokoku',
      imageUrl: img,
      url: 'https://drive.google.com/file/d/1OuhWu5SolrBGRihprkDJo_IxnImIfnfr/view?usp=sharing'
    },
    {
      id: 3,
      title: 'Bukabantuan Mitra Chatbot',
      description: 'I provide a chatbot feature when users complain about their problems in the Bukalapak Mitra app help center',
      imageUrl: img1,
      url: 'https://drive.google.com/file/d/1zpd_aKqlveEqohWZ3AzW-pmX42artUZV/view?usp=sharing'
    },
    {
      id: 4,
      title: 'Neu',
      description: 'This app was for payment and investment for millennial segment. I helped design and research the app',
      imageUrl: imgImage3,
      url: 'https://drive.google.com/file/d/1jsm4zeUjU9DYI2TF0QEG-x_AlJbYoMtE/view?usp=sharing'
    },
    {
      id: 5,
      title: 'Bukabantuan Revamp Project',
      description: 'I revamped our Bukalapak help center to provide better experience and journey when user complaining their problems',
      imageUrl: imgImage2,
      url: 'https://drive.google.com/file/d/1U8EYI3Q6EJjqHncB_-KOZ5CQnb36qwQY/view?usp=sharing'
    },
    {
      id: 6,
      title: 'Freelance Project: KCM Cinema',
      description: 'As a side project, i designed a cinema app for KCM Cinema. This app was for booking movie tickets and watching movies.',
      imageUrl: imgImage,
      overlayImageUrl: imgImage1,
      url: 'https://bioskopkcm.com/'
    }
  ];

  const articles = [
    {
      id: 1,
      title: 'The Illusion of the "No-Code" Designer',
      description: 'To build the product, you no longer need the code.',
      url: 'https://open.substack.com/pub/luthfirahmad/p/the-illusion-of-the-no-code-designer?r=jbqx5&utm_campaign=post&utm_medium=web&showWelcomeOnShare=true'
    },
    {
      id: 2,
      title: 'The Importance of Feedbacks',
      description: 'Ahhh, at last i can make a post again after such a long time!\nDunno, maybe it\'s already years? Haha just kidding!',
      url: 'https://open.substack.com/pub/luthfirahmad/p/the-importance-of-feedbacks?r=jbqx5&utm_campaign=post&utm_medium=web&showWelcomeOnShare=true'
    },
    {
      id: 3,
      title: 'Notes in My Thirties',
      description: 'This article is in Indonesian. Halo, pembaca...',
      url: 'https://open.substack.com/pub/luthfirahmad/p/notes-in-my-thirty?r=jbqx5&utm_campaign=post&utm_medium=web&showWelcomeOnShare=true'
    }
  ];

  const socialLinks = [
    {
      name: 'LinkedIn',
      icon: imgBasilLinkedinOutline,
      url: 'https://www.linkedin.com/in/luthfi-rahmad-s/'
    },
    {
      name: 'Upwork',
      icon: imgSimpleIconsUpwork,
      url: 'https://www.upwork.com/freelancers/~015c3b82338151289d?mp_source=share'
    },
    {
      name: 'Goodreads',
      icon: imgLaGoodreads,
      url: 'https://www.goodreads.com/user/show/100114994-luthfi-rahmad-susanto'
    },
    {
      name: 'Substack',
      icon: imgGroup,
      url: 'https://substack.com/@luthfirahmad/posts'
    }
  ];

  return (
    <div className="homepage" data-name="Homepage">
      {/* Left Section */}
      <div className="homepage-left" data-name="Left Section">
        <div className="decorative-ellipse-1">
          <img src={imgEllipse244} alt="" />
        </div>
        <div className="decorative-union">
          <img src={imgUnion} alt="" />
        </div>
        
        <div className="homepage-header">
          <Avatar 
            imageUrl={imgImageBackgroundRemoved1} 
            backgroundUrl={imgEllipse242} 
          />
          <StatusBadge status="Available" statusIcon={imgFrame1341149} />
        </div>

        <div className="homepage-intro">
          <h1 className="homepage-title">Hi, i am Luthfi</h1>
          <p className="homepage-description">
            Currently working in Bukalapak under Itemku subsidiary. Platform which sells digital top up and digital currency. Used to design app and web. 
          </p>
          <Button onClick={() => window.location.href = 'mailto:luthfirahmad@gmail.com'}>
            Contact me
          </Button>
        </div>
      </div>

      {/* Right Section */}
      <div className="homepage-right" data-name="Right Section">
        {/* Selected Projects Section */}
        <div className="section-header">
          <span className="section-icon">💣 </span>
          <span className="section-title">Selected Projects</span>
        </div>

        <div className="projects-grid">
          <div className="projects-row">
            <ProjectCard
              title={projects[0].title}
              description={projects[0].description}
              imageUrl={projects[0].imageUrl}
              overlayImageUrl={projects[0].overlayImageUrl}
              arrowIcon={imgSolarArrowRightUpLinear}
              url={projects[0].url}
            />
            <ProjectCard
              title={projects[1].title}
              description={projects[1].description}
              imageUrl={projects[1].imageUrl}
              overlayImageUrl={projects[1].overlayImageUrl}
              arrowIcon={imgSolarArrowRightUpLinear}
              url={projects[1].url}
            />
          </div>
          <div className="projects-row">
            <ProjectCard
              title={projects[2].title}
              description={projects[2].description}
              imageUrl={projects[2].imageUrl}
              overlayImageUrl={projects[2].overlayImageUrl}
              arrowIcon={imgSolarArrowRightUpLinear}
              url={projects[2].url}
            />
            <ProjectCard
              title={projects[3].title}
              description={projects[3].description}
              imageUrl={projects[3].imageUrl}
              overlayImageUrl={projects[3].overlayImageUrl}
              arrowIcon={imgSolarArrowRightUpLinear}
              url={projects[3].url}
            />
          </div>
          <div className="projects-row">
            <ProjectCard
              title={projects[4].title}
              description={projects[4].description}
              imageUrl={projects[4].imageUrl}
              overlayImageUrl={projects[4].overlayImageUrl}
              arrowIcon={imgSolarArrowRightUpLinear}
              url={projects[4].url}
            />
            <ProjectCard
              title={projects[5].title}
              description={projects[5].description}
              imageUrl={projects[5].imageUrl}
              overlayImageUrl={projects[5].overlayImageUrl}
              arrowIcon={imgSolarArrowRightUpLinear}
              url={projects[5].url}
            />
          </div>
        </div>

        {/* Articles Section */}
        <div className="section-header">
          <span className="section-icon">📝 </span>
          <span className="section-title">Articles</span>
        </div>

        <div className="articles-grid">
          <div className="articles-row">
            <Card
              title={articles[0].title}
              description={articles[0].description}
              arrowIcon={imgSolarArrowRightUpLinear}
              url={articles[0].url}
            />
            <Card
              title={articles[1].title}
              description={articles[1].description}
              arrowIcon={imgSolarArrowRightUpLinear}
              url={articles[1].url}
            />
          </div>
          <div className="articles-row">
            <Card
              title={articles[2].title}
              description={articles[2].description}
              arrowIcon={imgSolarArrowRightUpLinear}
              url={articles[2].url}
            />
            <div className="substack-cta">
              <p className="substack-text">Check another post on my Substack 👇</p>
              <Button onClick={() => window.open('https://substack.com/@luthfirahmad/posts', '_blank')}>
                Go to Substack
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Connect Section - Footer */}
      <div className="homepage-connect">
        <h2 className="connect-title">Thank you for visiting! 👋</h2>
        <p className="connect-subtitle">Let's connect</p>
        <div className="social-links">
          {socialLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              className="social-link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.name}
            >
              <img src={link.icon} alt={link.name} />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Homepage;

